/**
 * Extracts the query parameters from the given value.
 * @param value
 */
export const extractQueryParams = <T>(value?: string): T => {
    if (!value || value.length === 0) {
        return {} as T;
    }

    if (value.includes('error')) {
        const error = value.split('=')[1];
        return { error } as T;
    }

    const [tokenPart, expiresAtPart] = value?.split('&');
    if (!tokenPart || !expiresAtPart) {
        return {} as T;
    }

    const token = tokenPart.split('=')[1];
    const expiresAt = expiresAtPart.split('=')[1];
    return { token, expiresAt } as T;
};

export const isTokenExpired = (expiresAt?: string): boolean => {
    if (!expiresAt) {
        return true;
    }

    const expiresAtDate = new Date(expiresAt);
    return expiresAtDate.getTime() < new Date().getTime();
};
